var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import { IconButton, withStyles } from '@material-ui/core';
var useIconStyles = makeStyles(function (theme) {
    var _a;
    return createStyles({
        root: (_a = {},
            _a[theme.breakpoints.down('sm')] = {
                padding: theme.spacing(1.2),
            },
            _a),
    });
});
var StyledIconButton = withStyles({
    root: {
    // transition: 'scale 0.3s ease-in-out',
    // '&:hover': {
    //   scale: '1.2',
    // },
    },
})(IconButton);
function BaseIconButton(_a, ref) {
    var children = _a.children, props = __rest(_a, ["children"]);
    var classes = useIconStyles();
    return (React.createElement(StyledIconButton, __assign({}, props, { ref: ref, className: clsx(classes.root, props.className) }), children));
}
export default React.forwardRef(BaseIconButton);
